import styled from 'styled-components';
import { rhythm } from '../../utils/typography';
import React, { FC, useState } from 'react';
import { Strong } from '../Strong';

import { Topic } from './';
import { media } from '../../utils/styles';
import { useEventTracker } from '../../utils/analytics/useEventTracker';

const ComingSoon = styled.span<{ degree: number }>`
  opacity: ${({ degree }) => (!!degree ? '1' : '0')};
  transition: opacity 0.3s;
  font-size: ${rhythm(2 / 3)};
`;

const ComingSoonWrap = styled.span`
  ${media.mobile`display: flex; flex-flow: column;`}
`;

export type UpcomingTopicProps = {
  topic: string;
  degree: number;
  comingSoon?: boolean;
};

export const UpcomingTopic: FC<UpcomingTopicProps> = ({ topic, degree, comingSoon }) => {
  const [clicked, setClicked] = useState(false);
  const baseOpacity = 1.5;
  const trackClick = useEventTracker('click');
  const onClick = () => {
    trackClick({
      category: 'engagement',
      label: topic,
    });
    comingSoon && setClicked(true);
  };
  return (
    <Topic opacity={baseOpacity / degree} degree={degree} onClick={onClick}>
      <ComingSoonWrap>
        <span>
          / <Strong>{topic}</Strong>
        </span>{' '}
        <ComingSoon degree={clicked ? degree : 0}>- coming soon!</ComingSoon>
      </ComingSoonWrap>
    </Topic>
  );
};
